import ThFavoritesViewAbstract from '@/js/common/components/thFavorites/thFavoritesAbstract';

export default class thFavorites extends ThFavoritesViewAbstract {
    submitTourHunter() {
        const tourCriteria = this.getTourCriteria();

        if (!this.viewModel.get('requestInProgress')) {
            this.trackTourHunters(tourCriteria);
        }
        super.submitTourHunter();
   }
}
